import React, { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import { styled, SxProps, useTheme } from '@mui/material/styles';
import { CloseIcon } from 'src/components/SvgIcons/SvgIcons';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { useStacklineTheme } from '@stackline/ui';
import color from 'src/utils/colors';

export const useExtendedTheme = () => {
  const muiTheme = useTheme();
  const stacklineTheme = useStacklineTheme();

  return {
    ...muiTheme,
    ...stacklineTheme,
    customSpacing: stacklineTheme.spacing,
    spacing: [Object.values(stacklineTheme.spacing)]
  };
};

const Header = ({ title, onClose }: { title: string; onClose: () => void }) => (
  <>
    <Flex alignItems="center" className="genericModal__header">
      <Text variant="h4">{title}</Text>
      <CloseIcon
        onClick={onClose}
        style={{ cursor: 'pointer', width: '16px', height: '16px', marginLeft: 'auto', marginBottom: 'auto' }}
      />
    </Flex>
  </>
);

const Body = ({ children }: { children: ReactNode }) => (
  <Flex flexDirection="column" className="genericModal__body">
    {children}
  </Flex>
);

export const GenericStyledDialog = styled(Dialog)(({ theme, sx = {} }: { theme: any; sx: any }) => ({
  ...sx,
  '& .MuiPaper-root': {
    width: '640px',
    borderRadius: theme.customSpacing?.sm,
    padding: '24px 20px',
    overflow: 'hidden',
    ...sx?.['& .MuiPaper-root']
  },
  '& .genericModal__footer': {
    padding: '20px 36px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    backgroundColor: '#fff',
    borderTop: `1px solid ${color.graysSecondary}`,
    width: '100%'
  }
}));

export const GenericModal = ({
  open,
  onClose,
  sx,
  children
}: {
  open: boolean;
  onClose: () => void;
  sx?: SxProps;
  children: ReactNode;
}) => {
  const theme = useExtendedTheme();

  return (
    <GenericStyledDialog open={open} onClose={onClose} theme={theme as any} sx={sx}>
      {children}
    </GenericStyledDialog>
  );
};

const Footer = ({ children }: { children: ReactNode }) => (
  <Flex flexDirection="column" className="genericModal__footer">
    {children}
  </Flex>
);

GenericModal.Footer = Footer;
GenericModal.Header = Header;
GenericModal.Body = Body;
